import { http_api } from "../../leadg-api";
const search = (request, config) => {
    let url = `objects-search/search?notYetReviewed=${request.notYetReviewed}&page=${request.page}&pageSize=${request.pageSize}`;
    if (request.search)
        url += `&search=${encodeURIComponent(request.search)}`;
    if (request.sortField)
        url += `&sortField=${encodeURIComponent(request.sortField)}`;
    if (request.sortOrder)
        url += `&sortOrder=${request.sortOrder}`;
    return http_api.get(url, config);
};
const link = (input) => {
    return http_api.post("objects-search/link", input);
};
const unlink = (input) => {
    return http_api.post("objects-search/unlink", input);
};
// For an unlinked object only — reads Object fields directly by ObjectId, with
// no Lead/LeadObject join. Linked objects are opened via the existing
// LeadsObjectApi.getLeadObjectbyObjectId(leadObjectId) instead.
const getById = (objectId) => {
    return http_api.get(`objects-search/${objectId}`);
};
const ObjectSearchApi = {
    search,
    link,
    unlink,
    getById,
};
export default ObjectSearchApi;
